<template>
  <div class="yxtbiz-ability-preview">
    <single-column-container
      align="center"
      max-width="1280px"
    >
      <fix-header
        slot="header"
        :showBack="showBack"
        @back-click="backPage"
      >
        <div
          slot="center"
          class="title"
        >
          {{ previewBasic.name }}
        </div>
        <div
          slot="right"
          class="text-right"
        >
          <yxt-button
            @click="cancelPreview"
          >
            {{ $t('pc_gwnl_jq_btn_cancelPreview').d('关闭预览') }}
          </yxt-button>
        </div>
      </fix-header>
      <div v-if="Object.keys(previewBasic).length > 0">
        <single-column-item>
          <preview-basic
            ref="previewBasic"
            :preview-basic="previewBasic"
          />
        </single-column-item>
        <single-column-item>
          <preview-skills
            ref="previewSkills"
            :list="skillCatalogModels"
            :enable-skill-level="enableSkillLevel"
            :enable-weight-switch="enableWeightSwitch"
            :enable-excellent-level="enableExcellentLevel"
            class="mt32"
          />
        </single-column-item>
      </div>
    </single-column-container>
  </div>
</template>

<script>
import singleColumnContainer from './components/single-column-container';
import singleColumnItem from './components/single-column-item';
import fixHeader from './components/fix-header';
import previewBasic from './components/preview-basic';
import previewSkills from './components/preview-skills';
import { getSkillTemplateDetail } from './service';

export default {
  name: 'YxtbizAbilityPreview',
  components: { singleColumnContainer, singleColumnItem, fixHeader, previewBasic, previewSkills },
  props: {
    id: String,
    showBack: Boolean
  },
  data() {
    return {
      previewBasic: {},
      skillCatalogModels: [],
      enableWeightSwitch: 0,
      enableExcellentLevel: 0,
      enableSkillLevel: true
    };
  },
  mounted() {
    if (this.id) this.getTemplateDetail();
  },
  methods: {
    getTemplateDetail() {
      getSkillTemplateDetail(this.id).then((res) => {
        this.formatData({
          ...res,
          skillLevelSwitch: res.enableSkillLevel
        });
      });
    },
    formatData(data) {
      this.previewBasic = {
        name: data.name,
        enableSkillLevel: data.enableSkillLevel,
        modelDesc: data.modelDesc,
        attribute: data.attributeName,
        hierarchical: data.hierarchicalName,
        modelNum: data.modelNum
      };
      this.skillCatalogModels = data.skillCatalogModels;
      this.enableSkillLevel = data.skillLevelSwitch !== 0;
      this.enableExcellentLevel = data.enableExcellentLevel;
      this.enableWeightSwitch = data.enableWeightSwitch;
    },
    cancelPreview() {
      window.close();
    },
    backPage() {
      this.$router.go(-1);
    }
  }
};
</script>

